export enum ORDER_STATUS {
  ORDER_PLACED = 0,
  ACCEPTED_BY_MERCHANT = 1,
  REJECTED_BY_MERCHANT = 2,
  OUT_FOR_SERVICE = 3,
  REACHED_DESTINATION = 4,
  COMPLETED = 5,
  CANCELLED_BY_USER = 6,
  CANCELLED_BY_SERVICE_PARTNER = 7,
  PAYMENT_FAILED = 8,
  PAYMENT_DONE = 9,
}

/** Grouped list-filter values. Dashboard links use the same ids. */
export const ORDER_STATUS_GROUPS = {
  IN_PROGRESS: [
    ORDER_STATUS.ACCEPTED_BY_MERCHANT,
    ORDER_STATUS.OUT_FOR_SERVICE,
    ORDER_STATUS.REACHED_DESTINATION,
  ].join(","),
  CANCELLED: [
    ORDER_STATUS.CANCELLED_BY_USER,
    ORDER_STATUS.CANCELLED_BY_SERVICE_PARTNER,
  ].join(","),
} as const;

const OrderStatusMessages: { [key in ORDER_STATUS]: string } = {
  [ORDER_STATUS.ORDER_PLACED]: "Order Placed",
  [ORDER_STATUS.ACCEPTED_BY_MERCHANT]: "Accepted by Franchise",
  [ORDER_STATUS.REJECTED_BY_MERCHANT]: "Rejected by Franchise",
  [ORDER_STATUS.OUT_FOR_SERVICE]: "Out for Service",
  [ORDER_STATUS.REACHED_DESTINATION]: "Reached Destination",
  [ORDER_STATUS.COMPLETED]: "Completed",
  [ORDER_STATUS.CANCELLED_BY_USER]: "Cancelled by Customer",
  [ORDER_STATUS.CANCELLED_BY_SERVICE_PARTNER]: "Cancelled by Service Partner",
  [ORDER_STATUS.PAYMENT_FAILED]: "Payment Failed",
  [ORDER_STATUS.PAYMENT_DONE]: "Payment Done",
};

export const getOrderStatusMessage = (status: string | number): string => {
  const statusCode = typeof status === "number" ? status : parseInt(status, 10);

  if (statusCode in OrderStatusMessages) {
    return OrderStatusMessages[statusCode as ORDER_STATUS];
  }
  return "Unknown Status";
};

const OrderStatusColors: { [key in ORDER_STATUS]: string } = {
  [ORDER_STATUS.ORDER_PLACED]: "#ECA408",
  [ORDER_STATUS.ACCEPTED_BY_MERCHANT]: "#2563EB",
  [ORDER_STATUS.REJECTED_BY_MERCHANT]: "#DC2626",
  [ORDER_STATUS.OUT_FOR_SERVICE]: "#2563EB",
  [ORDER_STATUS.REACHED_DESTINATION]: "#2563EB",
  [ORDER_STATUS.COMPLETED]: "#059669",
  [ORDER_STATUS.CANCELLED_BY_USER]: "#DC2626",
  [ORDER_STATUS.CANCELLED_BY_SERVICE_PARTNER]: "#DC2626",
  [ORDER_STATUS.PAYMENT_FAILED]: "#DC2626",
  [ORDER_STATUS.PAYMENT_DONE]: "#059669",
};

export const getOrderStatusColor = (status: string | number): string => {
  const statusCode = typeof status === "number" ? status : parseInt(status, 10);

  if (statusCode in OrderStatusColors) {
    return OrderStatusColors[statusCode as ORDER_STATUS];
  }
  return "yellow";
};

export const isCancelledOrderStatus = (status: string | number): boolean => {
  const statusCode = typeof status === "number" ? status : parseInt(status, 10);
  return (
    statusCode === ORDER_STATUS.CANCELLED_BY_USER ||
    statusCode === ORDER_STATUS.CANCELLED_BY_SERVICE_PARTNER
  );
};
